module.exports = __webpack_public_path__ + "0707e45c0730b2f2d61b5fda548d89b1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-32.png
// module id = 2196
// module chunks = 0